export const CRITICAL_ALERTS_MODULE_KEY = 'flashAlerts';
export const CRITICAL_ALERTS_BASE_ROUTE = '/flashAlerts';
export const CRITICAL_ALERTS_FILTER_KEY = 'flashAlerts';
